<template>
  <div class="banner-wapper-container">
    <div class="header">
      <div class="logo">
        <img src="../../../assets/images/logo-2.png" alt="" />
      </div>
      <div class="nav">
        <router-link to="/home" class="active">{{ $t("common.navigation.title.home") }}</router-link>
        <router-link to="/about">{{ $t("common.navigation.title.about") }}</router-link>
        <router-link to="/query">{{ $t("common.navigation.title.query") }}</router-link>
        <router-link to="/track">{{ $t("common.navigation.title.track") }}</router-link>
        <router-link to="/contact">{{ $t("common.navigation.title.contact") }}</router-link>
      </div>
      <div class="language">
        <change-language></change-language>
      </div>
    </div>
    <div class="mask">
      <div class="mask-content">
        <h1>{{$t('home.banner.title')}}</h1>
        <p>{{$t('home.banner.description')}}</p>
        <div style="text-align:center;">
          <button class="jump-button" @click="$router.push('/contact')">{{$t('home.banner.contact-button')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChangeLanguage from "@/components/ChangeLanguage/ChangeLanguage";
export default {
  components: { ChangeLanguage },
  data() {
    return {

    };
  },
  mounted(){
    console.log();
  },
  methods: {},
};
</script>

<style lang="less" scoped>
@import url("../../../assets/iconfont/iconfont.css");
.banner-wapper-container {
  position: relative;
  width: 100%;
  height: 100vh;
  background: url("../../../assets/images/home/index-banner-bg03.jpg") no-repeat;
  background-size: 100% 100%;

  .header {
    margin: 24px 0 0 0;
    z-index: 10;
    position: absolute;
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;

    .logo {
      // margin-top: 12px;
      // background-color: red;
      width: 240px;
      img {
        width: 100%;
      }
    }
    .nav {
      display: flex;
      .active {
        color: #ff5d1b;
      }
      a {
        display: block;
        padding: 0 24px;
        font-size: 16px;
        color: #fff;
        &:hover {
          color: #ff5d1b;
        }
      }
    }
  }

  .mask {
    z-index: 1;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.45);
    display: flex;
    justify-content: center;
    align-items: center;

    .mask-content{
      margin-top: 48px;
      h1{
        text-align: center;
        font-size: 48px;
        color: #fff;
        letter-spacing: 3px;
      }
      p{
        font-size: 16px;
        color: #fff;
        text-align: center;
        // letter-spacing: 2px;
      }
      .jump-button{
        margin: 72px 0 0 0;
        padding: 12px 36px;
        // width: 300px;
        height: 60px;
        border-radius: 3px;
        background-color: #fff;
        border: none;
        font-size: 24px;
        letter-spacing: 2px;
        color: #ff5d1b;
        cursor: pointer;
        opacity: 1;
        transition: all 0.4s;

        &:hover{
          opacity: 0.8;
        }
      }
      
    }
  }
}
</style>